import { useGetList } from 'react-admin';
import { CircularProgress, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, ToggleButtonGroup, ToggleButton, Box, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { downloadEncodedCSV } from '../../../utils/functions';
import moment from 'moment';

const MemberLead = () => {
	const [clickFilter, setClickFilter] = useState<'all' | 'true' | 'false'>('all');
	const [usernameFilter, setUsernameFilter] = useState('');
	const { data, isLoading, error } = useGetList('member-leads', {
		pagination: { page: 1, perPage: 1000 },
		meta: {
			transformResponse: (response: any) => {
				return {
					data: response.data || [],
					total: response.results || 0
				};
			}
		}
	});

	const handleFilterChange = (event: React.MouseEvent<HTMLElement>, newFilter: 'all' | 'true' | 'false') => {
		setClickFilter(newFilter);
	};

	const handleUsernameFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUsernameFilter(event.target.value);
	};

	const handleExport = () => {
		const dataToExport = filteredData.map((row: any) => ({
			link_id: row.link_id,
			link: row.link,
			username: row.member ? `${row.member.first_name} ${row.member.last_name}` : '-',
			company: row.member?.company?.english_name || '-',
			is_click: row.is_click ? 'כן' : 'לא',
			click_date: row.click_date ? new Date(row.click_date).toLocaleString('he-IL') : '-',
			source: row.source || '-',
			created_at: new Date(row.created_at).toLocaleString('he-IL'),
			updated_at: new Date(row.updated_at).toLocaleString('he-IL')
		}));

		downloadEncodedCSV(
			dataToExport,
			['link_id', 'link', 'username', 'company', 'is_click', 'click_date', 'source', 'created_at', 'updated_at'],
			`member_leads_${moment().format('YYYY_MM_DD')}`
		);
	};

	if (isLoading) return <CircularProgress />;
	if (error) return <Typography color="error">Error loading member leads: {error.message}</Typography>;
	if (!data) return <Typography>No data available</Typography>;

	const filteredData = data.filter((row: any) => {
		const matchesClickFilter = clickFilter === 'all' || row.is_click === (clickFilter === 'true');
		const matchesUsernameFilter = !usernameFilter || 
			(row.member && 
				(`${row.member.first_name} ${row.member.last_name}`.toLowerCase().includes(usernameFilter.toLowerCase())));
		return matchesClickFilter && matchesUsernameFilter;
	});

	return (
		<Box>
			<Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
				<ToggleButtonGroup
					value={clickFilter}
					exclusive
					onChange={handleFilterChange}
					aria-label="click filter"
				>
					<ToggleButton value="all" aria-label="all">
						הכל
					</ToggleButton>
					<ToggleButton value="true" aria-label="clicked">
						נלחץ
					</ToggleButton>
					<ToggleButton value="false" aria-label="not clicked">
						לא נלחץ
					</ToggleButton>
				</ToggleButtonGroup>
				<TextField
					label="שם משתמש"
					value={usernameFilter}
					onChange={handleUsernameFilterChange}
					variant="outlined"
					size="small"
					sx={{ minWidth: 200 }}
				/>
				<Button 
					variant="contained" 
					onClick={handleExport}
					sx={{ ml: 'auto' }}
				>
					ייצוא ל-CSV
				</Button>
			</Box>
			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>מזהה קישור</TableCell>
							<TableCell>קישור</TableCell>
							<TableCell>שם משתמש</TableCell>
							<TableCell>חברה</TableCell>
							<TableCell>נלחץ</TableCell>
							<TableCell>תאריך לחיצה</TableCell>
							<TableCell>מקור</TableCell>
							<TableCell>נוצר בתאריך</TableCell>
							<TableCell>עודכן בתאריך</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredData.map((row: any) => (
							<TableRow key={row._id}>
								<TableCell>{row.link_id}</TableCell>
								<TableCell>{row.link}</TableCell>
								<TableCell>{row.member ? `${row.member.first_name} ${row.member.last_name}` : '-'}</TableCell>
								<TableCell>{row.member?.company?.english_name || '-'}</TableCell>
								<TableCell>{row.is_click ? 'כן' : 'לא'}</TableCell>
								<TableCell>{row.click_date ? new Date(row.click_date).toLocaleString('he-IL') : '-'}</TableCell>
								<TableCell>{row.source || '-'}</TableCell>
								<TableCell>{new Date(row.created_at).toLocaleString('he-IL')}</TableCell>
								<TableCell>{new Date(row.updated_at).toLocaleString('he-IL')}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default MemberLead;
